<template lang="pug">
div
  el-form-item
    template(#label) 文件类型
      el-tooltip(effect="light", content="请输入后缀名并使用';'分割开,不区分大小写,列:txt;pdf;jpg")
        i.el-icon-info
    el-input(v-model="fileType")
  el-form-item(label="模板文件")
    el-button(@click="uploadClick") 上传模版
  el-form-item(label-width="0")
    FileList(:file-list="fileList", delete)
  el-divider 列表样式
  el-form-item(label="列表风格")
    el-radio-group(v-model="listStyle")
      el-radio(v-for="{ label, value } in listStyles", :label="value", :key="value") {{ label }}
  el-form-item(v-if="!isSimpleStyle", key="btnStyle", label="操作按钮显示")
    el-radio-group(v-model="btnStyle")
      el-radio(v-for="{ label, value } in btnStyles", :label="value", :key="value") {{ label }}
  el-form-item(label="本地上传")
    el-switch(v-model="upload")
    el-checkbox.showPanel(v-if="upload", v-model="showPanel", :true-label="1", :false-label="0") 上传面板
  el-form-item(label="知识库文件夹")
    el-switch(v-model="selectEntFile")
  el-form-item(label="项目文件夹")
    el-switch(v-model="selectPrjFile")
  template(v-if="selectPrjFile")
    el-divider 指定选择目录
    el-form-item(key="root", label="项目目录限制")
      el-dropdown(@command="commandOfDir")
        el-input(:value="prjRootObj.folderStr", size="mini", readonly)
        template(#dropdown)
          el-dropdown-menu
            el-dropdown-item(icon="el-icon-edit", :command="openRootDoc") 编辑
            el-dropdown-item(icon="el-icon-delete", :command="clearRootDirectory") 清空
  el-divider 指定保存目录
  el-form-item(label="允许用户指定存放目录", label-width="150px")
    el-switch(v-model="isNeedTargetFolder", :active-value="1", :inactive-value="0")
  el-form-item(label-position="top", label-width="100px", label="选择存储目录")
    el-dropdown(@command="commandOfDir")
      el-input(:value="defaultSaveDirectoryStr", size="mini", readonly)
      template(#dropdown)
        el-dropdown-menu
          el-dropdown-item(icon="el-icon-edit", :command="openSaveDoc") 编辑
          el-dropdown-item(icon="el-icon-delete", :command="clearDirectory") 清空
          el-dropdown-item(icon="el-icon-document-copy", :command="copyPath") 复制路径
          el-dropdown-item(icon="el-icon-document-copy", :command="copyId") 复制ID
  el-form-item(label="存储策略")
    el-radio-group(v-model="sameNameStrategy")
      el-radio(v-for="{ label, value } in collision", :label="value", :key="value") {{ label }}
  el-form-item(label="文件中转方式")
    el-select(v-model="fileTransferCode")
      el-option(label="复制", value="copy")
      el-option(label="移动", value="move")
  template(v-if="!isSimpleStyle")
    el-divider 字典列配置
    el-form-item(label-width="0")
      dict-select(v-model="dictType", clearable)
</template>
<script>
import { uploader } from "@/CommonDP/utils/IUploader/dp.js";
import { mapVFOptions, settingMixin } from "../utils";
import FileList from "@/CommonDP/components/FileList/docFileList.vue";
import { VF_UPLOAD_ENUM } from "./utils";
import DictSelect from "@/CommonDP/VForm/dict/dict-select.vue";
import ModuleFolder from "./moduleFolder/index.vue";
import asyncCom from "@/CommonDP/commons/asyncCom";
import { last } from "lodash-es";
const rootList = [
  { cnName: "设计区", id: VF_UPLOAD_ENUM.DESIGN },
  { cnName: "提资区", id: VF_UPLOAD_ENUM.TIZI },
  { cnName: "成品区", id: VF_UPLOAD_ENUM.PROOFR }
];
export default {
  components: {
    DictSelect,
    FileList
  },
  mixins: [settingMixin],
  data() {
    return {
      btnStyles: [
        { label: "文字", value: VF_UPLOAD_ENUM.text },
        { label: "图标", value: VF_UPLOAD_ENUM.icon }
      ],
      listStyles: [
        { label: "列表", value: "" },
        { label: "精简", value: VF_UPLOAD_ENUM.simple }
      ],
      collision: [
        { label: "覆盖(默认)", value: VF_UPLOAD_ENUM.OVER_WRITE },
        { label: "重命名", value: VF_UPLOAD_ENUM.RENAME }
      ]
    };
  },
  computed: {
    ...mapVFOptions(
      "templateFolderId",
      "sameNameStrategy",
      "defaultSaveDirectory",
      "dictType",
      "prjRoot",
      "prjRootName",
      "prjRootModule",
      "isNeedTargetFolder",
      "fileTransferCode",
      "fileType",
      "listStyle",
      "btnStyle",
      "upload",
      "showPanel",
      "selectEntFile",
      "selectPrjFile",
      {
        fileList: "template"
      }
    ),
    prjRootObj() {
      const { prjRoot = "", prjRootName, prjRootModule } = this;
      return {
        folderId: prjRoot,
        moduleId: prjRootModule,
        folderStr: prjRootName || rootList.find(({ id }) => id === prjRoot)?.cnName || prjRoot
      };
    },
    defaultSaveDirectoryObj() {
      const folders = this.defaultSaveDirectory || [];
      return folders.slice(-1)[0];
    },
    defaultSaveDirectoryStr() {
      const list = this.defaultSaveDirectory || [];
      return list.map(({ folderName }) => folderName).join("/");
    },
    // 精简模式
    isSimpleStyle() {
      return this.listStyle === VF_UPLOAD_ENUM.simple;
    }
  },
  methods: {
    commandOfDir(fn) {
      return fn.call(this);
    },
    async uploadClick() {
      const params = await uploader.getHiddenParams({});
      const list = await uploader.open({
        params,
        once: true,
        showPanel: true,
        multiple: true
      });
      list.forEach(this.fileAdded);
    },
    clearDirectory() {
      this.setDirectory([]);
    },
    setDirectory(data) {
      this.defaultSaveDirectory = data || [];
      this.templateFolderId = this.defaultSaveDirectoryObj?.folderId || "";
    },
    clearRootDirectory() {
      this.prjRoot = "";
      this.prjRootModule = "";
      this.prjRootName = "";
    },
    async copyPath() {
      this.copyValue(this.defaultSaveDirectoryStr);
    },
    async copyId() {
      this.copyValue(this.templateFolderId);
    },
    async copyValue(value) {
      if (value.length) {
        await this.$copyText(value);
        this.$message.success("复制成功!");
      } else {
        this.$message.warning("未选择数据");
      }
    },
    async openRootDoc() {
      const { prjRoot, prjRootModule } = this;
      const obj = { defaultIds: prjRoot ? [prjRoot] : [], moduleId: prjRootModule };
      const { paths } = await this.openDoc(obj);
      const folder = last(paths);
      if (!folder) return this.clearRootDirectory();
      this.prjRoot = folder.folderId;
      this.prjRootModule = folder.moduleId;
      this.prjRootName = paths.map(({ folderName }) => folderName).join("/");
    },
    async openSaveDoc() {
      const folder = this.defaultSaveDirectoryObj;
      const defaultIds = folder ? [folder.folderId] : [];
      const moduleId = folder ? folder.moduleId : "";
      const { paths } = await this.openDoc({ defaultIds, moduleId });
      this.setDirectory(paths);
    },
    async openDoc(data) {
      return asyncCom(ModuleFolder, data);
    },
    fileAdded(file) {
      const baseFile = {
        fileId: file.fileId,
        fileSource: "3",
        fileName: file.fileName,
        version: file.versionIds,
        fileType: file.fileType,
        prjId: "EnterpriseDoc"
      };
      this.fileList.push(baseFile);
    }
  }
};
</script>
<style lang="scss" scoped>
.showPanel {
  margin-left: 16px;
}
</style>
